var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 27.2143C8.27143 27.2143 2.78571 21.7286 2.78571 15C2.78571 8.27143 8.27143 2.78572 15 2.78572C18.2377 2.79138 21.3412 4.08006 23.6305 6.36945C25.9199 8.65885 27.2086 11.7623 27.2143 15C27.2143 21.7286 21.7286 27.2143 15 27.2143ZM15 30C23.2714 30 30 23.2714 30 15C30 6.72857 23.2714 2.27382e-06 15 1.55198e-06C6.72857 8.3014e-07 1.10076e-06 6.72857 3.76373e-07 15C-3.48009e-07 23.2714 6.72857 30 15 30ZM12.8571 23.5714L17.1429 23.5714L17.1429 12.8571L12.8571 12.8571L12.8571 23.5714ZM12.8571 10.7143L17.1429 10.7143L17.1429 6.42857L12.8571 6.42857L12.8571 10.7143Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.6637b45accc811e8eea05a31cfab4472.svg";
export { ForwardRef as ReactComponent };